import { useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import { FormContext, FormDispatchContext } from '../../contexts/FormContext';

// ----------------------------------------------------------------------

export default function StaticTitle(props) {

  const settings = useContext(FormContext);
  const settingsUpdate = useContext(FormDispatchContext);

  const handleChange = (e) => { 
    settingsUpdate({ type: 'set_review_title', reviewTitle: e.target.value });
    settingsUpdate({ type: 'set_question_answer', questionID: props.question.question_id, providedAnswer: e.target.value });
    settingsUpdate({ type: 'set_review_title_was_prefilled', value: false });    
  }
  
  return ( 
    <>
    { !settings?.titleWasPrefilled && ( 
    <Box className="workingfeedback-question-block">
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="body2" className="workingfeedback-question-title" component="h6">{ props.question.text } <span className="workingfeedback-required-star">*</span></Typography>
                <TextField 
                  size="small" 
                  className="workingfeedback-question-textfield" 
                  sx={{ width: '100%' }} 
                  placeholder={ props.question.default_value } 
                  value={settings?.reviewTitle} 
                  defaultValue={props.invite?.description} 
                  autoComplete="off" 
                  maxLength="70" 
                  onChange={(e) => handleChange(e)}
                  />
                { settings?.titleWasPrefilled && (
                    <Alert icon={false} severity="info" sx={{ padding: '0px 10px', marginTop: '5px' }}>
                        <Typography variant="body2">We've pre-filled this box based on a suggestion, but feel free to change it.</Typography>
                    </Alert>
                )}
            </Grid>
        </Grid>
    </Box>
    )}
    </>
  )
}
